import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/footer/linkedin.webp")